import React from 'react';

const IconLogo = () => (
 <svg width="97" height="116" viewBox="0 0 97 116" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="5" width="97" height="106" fill="#09182F"/>
<path d="M20.4545 93V23.1818H28.9091V54.2727H66.1364V23.1818H74.5909V93H66.1364V61.7727H28.9091V93H20.4545Z" fill="#51D2B9"/>
</svg>
);

export default IconLogo;
